// Generic no-op shim for native modules that have no web equivalent but are
// only *called* behind user actions (camera, device-info, analytics, sentry,
// sms-retriever, fbsdk, idfa, play-referrer...). They must resolve at
// module-load; their methods are never hit on the render path. A recursive
// callable Proxy satisfies any shape: default import, named imports, X.y.z(),
// and X() — all return another no-op.
function createNoop() {
  const fn = function () {
    return createNoop();
  };
  return new Proxy(fn, {
    get(_t, prop) {
      if (prop === "__esModule") return true;
      if (prop === "default") return root;
      // Not a thenable — so ESM/webpack interop doesn't await the module,
      // and `await nativeCall()` resolves to the proxy instead of hanging.
      if (prop === "then") return undefined;
      if (prop === Symbol.toPrimitive) return () => "";
      if (typeof prop === "symbol") return undefined;
      return createNoop();
    },
    // Calls return null: harmless for `analytics.trackEvent()`, and makes the
    // proxy a VALID null-rendering React component if used in JSX (e.g. a
    // native <Loader/> off the render path). Chained property access still
    // returns a proxy via get(), so `X.y.z` resolves before the final call.
    apply() {
      return null;
    },
  });
}
const root = createNoop();
module.exports = root;
